import { useAuthStore } from "@kaplan-labs/up-auth-api-client";

import { useTheme } from "@up/data";
import { Animation, Auth } from "@up/ui";

import type { PropsWithChildren } from "react";

export function EnforceAuthentication({ children }: PropsWithChildren) {
  const auth = useAuthStore();
  const theme = useTheme();

  return auth.currentUser ? (
    children
  ) : (
    <div className="mx-auto max-w-xl md:px-8 pt-8 animation-fade-in">
      <h1 className={theme.heading1Class}>Application</h1>
      <div className="h-8" aria-hidden />
      <Animation type="splash-in">
        <Auth />
      </Animation>
    </div>
  );
}
